<!--
 * @Author: 张天昊
 * @Date: 2024-05-25 17:06:01
 * @LastEditTime: 2024-06-04 11:03:05
 * @LastEditors: 张天昊
 * @Description: 空状态
 * @FilePath: /Mobile/src/pages/itineraryUniversal/components/DataEmpty.vue
-->
<script>
import { defineComponent } from 'vue';
import icEmpty from '@/assets/itineraryUniversal/ic-empty.png';

export default defineComponent({
  props: {
    size: String
  },
  setup() {
    return {
      icEmpty
    };
  }
});
</script>

<template>
  <van-empty
    :image-size="$px2rem(48)"
    :image="icEmpty"
    :class="[size]"
    class="custom-empty bg-white rounded-4"
    description="暂无数据"
  />
</template>

<style scoped>
.custom-empty.van-empty {
  padding: 105px 0;
}
.custom-empty.van-empty.small {
  padding: 45px 0;
}
.custom-empty.van-empty:deep(.van-empty__description) {
  font-size: 14px;
  line-height: 16px;
  margin-top: 8px;
  color: #71747a;
}
</style>
